"use client"

import dynamic from "next/dynamic"
import { ComponentType } from "react"

interface AISummaryBlockProps {
    title: string
    url: string
    className?: string
}

// Loading skeleton component
const LoadingSkeleton = () => (
    <div className="mx-auto mb-6 rounded-xl bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 border border-blue-100 shadow-sm animate-pulse">
        <div className="max-w-4xl mx-auto px-4 py-3">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-blue-200"></div>
                        <div className="h-4 bg-blue-200 rounded w-24"></div>
                    </div>
                </div>
                <div className="flex items-center justify-center gap-2 flex-wrap">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <div key={index} className="h-8 bg-blue-200 rounded-lg w-16 sm:w-20"></div>
                    ))}
                </div>
            </div>
        </div>
    </div>
)

// Lazy load the AISummaryBlock component with better error handling
const AISummaryBlock = dynamic(
    () => import("./AISummaryBlock") as Promise<{ default: ComponentType<AISummaryBlockProps> }>,
    {
        ssr: false,
        loading: LoadingSkeleton,
    }
)

export default AISummaryBlock
